import { render, staticRenderFns } from "./AddCardFooter.vue?vue&type=template&id=955129a4&scoped=true&"
import script from "./AddCardFooter.vue?vue&type=script&lang=js&"
export * from "./AddCardFooter.vue?vue&type=script&lang=js&"
import style0 from "./AddCardFooter.vue?vue&type=style&index=0&id=955129a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955129a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VFlex,VFooter,VLayout,VSelect})
